import { render, staticRenderFns } from "./restauration.vue?vue&type=template&id=40f8489f&"
import script from "./restauration.vue?vue&type=script&lang=js&"
export * from "./restauration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports